import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useGutterBottom = () => {
  const theme = useTheme();
  return useMemo(() => {
    const staticMargin = 3;
    const fontSize = parseFloat(theme.typography.body2.fontSize as string);
    const htmlFontSize = theme.typography.htmlFontSize || 16;

    const fontSizePx = fontSize > 8 ? fontSize : fontSize * htmlFontSize;

    const lineHeightPx = fontSizePx + staticMargin;
    return lineHeightPx + 'px';
  }, [theme]);
};

export default useGutterBottom;
